import ossImgCompress from '@/utils/ossImgCompress';
import {
  resourcesMapperDE,
  resourcesMapperEN,
  resourcesMapperES,
  resourcesMapperFR,
  resourcesMapperKR,
  resourcesMapperIT,
  resourcesMapperTW,
  resourcesMapperJP,
} from './GO3SProductScene';

// deprecated
const GO3SBlackScene = [
  {
    url: 'https://res.insta360.com/static/21a442926728ffacb29ee4549b4c0e45/1_hands-free-POVs_1280.jpg',
    urlL: 'https://res.insta360.com/static/f1c5afa65cef55a7b7f3175a924a409c/%EF%BC%881%EF%BC%894K%20Hands-Free%20POVs.jpg',
    url_m: 'https://res.insta360.com/static/21a442926728ffacb29ee4549b4c0e45/1_hands-free-POVs_1280.jpg',
    url_s: 'https://res.insta360.com/static/1d31b01b93f52e93e3961ff796975db6/1_hands-free-POVs_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/70282f2d71c03a0c49cc8984cedee9a0/2_small-and-lightweight_1280.jpg',
    urlL: 'https://res.insta360.com/static/202135f4564ce6451e47144b0b5a2e59/%EF%BC%882%EF%BC%89Small%20&%20Lightweight.jpg',
    url_m: 'https://res.insta360.com/static/70282f2d71c03a0c49cc8984cedee9a0/2_small-and-lightweight_1280.jpg',
    url_s: 'https://res.insta360.com/static/eedcf5ee1b02dc1029a77ef4a55091e5/2_small-and-lightweight_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/a7b717d9090e67239b1f48d2fdd6a99c/3_mount-anywhere_1280.jpg',
    urlL: 'https://res.insta360.com/static/5cf8dc7c23e35dd33bed9aba6d3ccddf/%EF%BC%883%EF%BC%89Mount%20Anywhere.jpg',
    url_m: 'https://res.insta360.com/static/a7b717d9090e67239b1f48d2fdd6a99c/3_mount-anywhere_1280.jpg',
    url_s: 'https://res.insta360.com/static/9cf47a7c141e0c02a046650bfbf9b6ba/3_mount-anywhere_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/7b493ba8ccdeb7738d0e3d4a2a082112/4_apple-find-my_1280.jpg',
    urlL: 'https://res.insta360.com/static/5b2e8c07a9279d5fd063ba1faeaa6447/%EF%BC%884%EF%BC%89Apple%20Find%20My.jpg',
    url_m: 'https://res.insta360.com/static/7b493ba8ccdeb7738d0e3d4a2a082112/4_apple-find-my_1280.jpg',
    url_s: 'https://res.insta360.com/static/031cae6a1771777a83639761d0d9411d/4_apple-find-my_780.jpg',
  },
];

// deprecated
const GO3SWhiteScene = [
  {
    url: 'https://res.insta360.com/static/4efa5a9c9ea918554aa6a27475fda7e7/1_4K-hands-free-POVS_1280.jpg',
    urlL: 'https://res.insta360.com/static/6ef6ca0904450f359295d5fb2da1ff4c/(1)4K%20Hands-Free%20POVs.jpg',
    url_m: 'https://res.insta360.com/static/4efa5a9c9ea918554aa6a27475fda7e7/1_4K-hands-free-POVS_1280.jpg',
    url_s: 'https://res.insta360.com/static/968baa8a3756b0b3e903e8f8659758b3/1_4K-hands-free-POVS_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/dd5c515898969fc094fe3aa25ea3e31b/2_samll-and-lightweight_1280.jpg',
    urlL: 'https://res.insta360.com/static/c15aa54ae3badbad67987dfa3cec1dde/(2)Small%20&%20Lightweight.jpg',
    url_m: 'https://res.insta360.com/static/dd5c515898969fc094fe3aa25ea3e31b/2_samll-and-lightweight_1280.jpg',
    url_s: 'https://res.insta360.com/static/c1c7765927ddce3aa03788e4e596ce6e/2_samll-and-lightweight_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/6a44b1ec8c3f86115802f4098fb89de8/3_mount-anywhere_1280.jpg',
    urlL: 'https://res.insta360.com/static/faac74ca1e46939cf63e615734f8b775/(3)Mount%20Anywhere.jpg',
    url_m: 'https://res.insta360.com/static/6a44b1ec8c3f86115802f4098fb89de8/3_mount-anywhere_1280.jpg',
    url_s: 'https://res.insta360.com/static/293ef06e428c60c4228e984ecf659224/3_mount-anywhere_780.jpg',
  },
  {
    url: 'https://res.insta360.com/static/f70d4f96e894b44110718aadd30e78a0/4_apple-find-my_1280.jpg',
    urlL: 'https://res.insta360.com/static/a4c29f8569baf860b397f9d11ceeaed2/(4)Apple%20Find%20My.jpg',
    url_m: 'https://res.insta360.com/static/f70d4f96e894b44110718aadd30e78a0/4_apple-find-my_1280.jpg',
    url_s: 'https://res.insta360.com/static/ae4346f05983ee87930bf7f3e1972987/4_apple-find-my_780.jpg',
  },
];

// deprecated
const GO3SSceneMastListForABTesting = new Map([
  [3120, GO3SBlackScene],
  [3125, GO3SWhiteScene],
  [3130, GO3SBlackScene],
  [3135, GO3SWhiteScene],
]);

/**
 * GO3S 产品页主图ABTest
 * 【PROD】：https://arashivision.feishu.cn/wiki/TOQ2wavAuirkhWk3ByBcy0ownLg
 */
const handleGO3SProductSceneABTest = ({ cid, displayResources, webp, lang, immutable = false }) => {
  const resourcesMapper = {
    'en_us': resourcesMapperEN,
    'fr_fr': resourcesMapperFR,
    'de_de': resourcesMapperDE,
    'es_es': resourcesMapperES,
    'ko_kr': resourcesMapperKR,
    'it_it': resourcesMapperIT,
    'zh_tw': resourcesMapperTW,
    'ja_jp': resourcesMapperJP,
  }[lang];

  if (!resourcesMapper) return [];

  const replacementResources = resourcesMapper.get(cid);
  if (!replacementResources) return [];
  if (immutable) {
    return [
      displayResources[0],
      ...replacementResources.map((item) => ({
        ...item,
        url: ossImgCompress(item.url, { webp }),
        urlL: ossImgCompress(item.urlL, { webp }),
        url_m: ossImgCompress(item.url_m, { webp }),
        url_s: ossImgCompress(item.url_s, { webp }),
      })),
      ...displayResources.slice(1),
    ];
  } else
    displayResources.splice(
      1,
      0,
      ...replacementResources.map((item) => ({
        ...item,
        url: ossImgCompress(item.url, { webp }),
        urlL: ossImgCompress(item.urlL, { webp }),
        url_m: ossImgCompress(item.url_m, { webp }),
        url_s: ossImgCompress(item.url_s, { webp }),
      }))
    );
};

const GO3SProductSceneCommodities = new Set([
  3125, 3135, 3120, 3130, 3121, 3131, 3126, 3136, 3469, 3470, 3471, 3472, 3122, 3132, 3127, 3137, 3478, 3479, 3480,
  3481, 3123, 3133, 3128, 3138,
]);

/**
 * onex2产品页主图首次进入则自动跳转到第二张场景图
 */
const onex2ProductSceneCommodities = new Set([1164]);
const onex2ProductSceneCountry = new Set([
  'PT',
  'DK',
  'LT',
  'LU',
  'HR',
  'LV',
  'HU',
  'MC',
  'IE',
  'EE',
  'MT',
  'IS',
  'RO',
  'NL',
  'BE',
  'FI',
  'BG',
  'SE',
  'SI',
  'SK',
  'CH',
  'GR',
  'CY',
  'CZ',
  'PL',
  'LI',
  'US',
  'IL',
  'AE',
  'IN',
  'AU',
  'NO',
  'NZ',
  'SA',
  'BR',
  'GB',
  'CA',
  'KW',
  'ID',
  'MY',
  'VN',
  'BN',
  'SG',
  'TH',
  'PH',
  'IT',
  'KR',
  'FR',
  'AD',
  'ES',
  'MX',
  'JP',
  'HK',
  'MO',
  'TW',
  'AT',
  'DE',
]);

const getSnowKitSceneConfig = (code) => {
  return {
    /**
     * global: 1/13 15:00 - 2/28 15:00
     * jp: 1/15 16:00 - 2/28 15:00
     */
    time: ['JP'].includes(code) ? [1736928000000, 1740726000000] : [0, 1740726000000],
    enabledCmds: ['2999', '3000', '3010', '3011'],
  };
};

/**
 * @description AcePro2 产品页主图ABTest
 * 文档链接：https://arashivision.feishu.cn/docx/Fn4dd3UDUoxeq7xHfvGcrKTHnZa?from=from_lark_group_search&hyperlink_open_type=lark.open_in_browser&disposable_login_token=eyJ1c2VyX2lkIjoiNzAyOTYyMDc0NjY0OTUzNDQ2NyIsImRldmljZV9sb2dpbl9pZCI6IjcwOTkyNzcwMTcyOTU4OTY1NzciLCJ0aW1lc3RhbXAiOjE3NDE1OTExMzgsInVuaXQiOiJldV9uYyIsInB3ZF9sZXNzX2xvZ2luX2F1dGgiOiIxIiwidmVyc2lvbiI6InYzIiwidGVuYW50X2JyYW5kIjoiZmVpc2h1IiwicGtnX2JyYW5kIjoi6aOe5LmmIn0=.88d75656c89dabfd02332b49e15ee6b95c895b20b7b23d2c236dc16a58a3bd53
 * 每个字段对应的图片尺寸
 * url：1280*1280
 * urlL：2000*2000
 * url_m：1280*1280
 * url_s：780*780
 */
const hanldeAP2ABT = ({ cid, displayResources, webp }) => {
  const AP2ABTSource = new Map([
    // 标准套装 - 单电
    [
      [3619],
      [
        'https://res.insta360.com/static/a24a414b12ba7da5c5296c1ee46f1746/1%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90_%E5%8D%95%E7%94%B5.jpg',
        'https://res.insta360.com/static/e7dcb82771eccee290fb9bd0eecba130/2%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/1950f0e3bbb5e9f6b86b1e7b0b424fc7/3%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/7c1d27a77a7ebe44cad010b659442c28/4%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/8f5ab60ea88e93ef48e4b188f2389efb/5%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/37d6b7268f914a513b56f695b7e3b057/6%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/e51a09ba32d7b69c37383d7397bd59a5/7%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    [
      // 标准套装 - 双电
      [3611],
      [
        'https://res.insta360.com/static/48a8d355c0f608c781e550532c578caf/1%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90_%E5%8D%95%E7%94%B5-1.jpg',
        'https://res.insta360.com/static/e7dcb82771eccee290fb9bd0eecba130/2%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/1950f0e3bbb5e9f6b86b1e7b0b424fc7/3%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/7c1d27a77a7ebe44cad010b659442c28/4%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/8f5ab60ea88e93ef48e4b188f2389efb/5%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/37d6b7268f914a513b56f695b7e3b057/6%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/e51a09ba32d7b69c37383d7397bd59a5/7%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    // 创作者套装
    [
      [3620, 3612],
      [
        'https://res.insta360.com/static/2f8e9d9f72ba82f9fcd4673d591796e7/1%E5%88%9B%E4%BD%9C%E8%80%85%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/5603a35a7df4d9e0eb2428fa9e3ed1c8/2%E5%88%9B%E4%BD%9C%E8%80%85%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/8adfd5fcc5ca4b73cdd104b4b5143be9/3%E5%88%9B%E4%BD%9C%E8%80%85%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/04bad004f0926d06d41c7d29980f6427/4%E5%88%9B%E4%BD%9C%E8%80%85%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    //Vlog套餐
    [
      [3621, 3613],
      [
        'https://res.insta360.com/static/4de8f36756519e1a5f28267a90e1df60/1Vlog%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/21df886d25f311b4341678988fb3501d/2Vlog%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/c347a210252ee0361d3fbc6259efa573/3Vlog%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    // 全能套装 - 单/双电
    [
      [3622, 3614],
      [
        'https://res.insta360.com/static/aa141c941933f0a07d5675e612c80d68/1%E5%85%A8%E8%83%BD%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/43dbe914db649a3b10a7680c7b4ad11c/2%E5%85%A8%E8%83%BD%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/7b36b232ecef5a8c6df53c43db765147/3%E5%85%A8%E8%83%BD%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/f8564f1c9fca2b7307632e461ed3f9d5/4%E5%85%A8%E8%83%BD%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    //自行车骑行套餐
    [
      [3623, 3615],
      [
        'https://res.insta360.com/static/b3eb512e42a703d85d4a8b030f051c8e/1%E8%87%AA%E8%A1%8C%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/27971549b9aae0c34b8a12bdc4ab8e77/2%E8%87%AA%E8%A1%8C%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/9ee6e92c98412dd74c3e7089b86e2699/3%E8%87%AA%E8%A1%8C%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    // 摩托车骑行套餐
    [
      [3624, 3616],
      [
        'https://res.insta360.com/static/8d16853a8bf5c2d08eb001aec93ad639/1%E6%91%A9%E6%89%98%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/f207209f164d7b098796f573da84fce1/2%E6%91%A9%E6%89%98%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/75c48fb018df7723691fdf0ad8781327/3%E6%91%A9%E6%89%98%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/c18a5b259993fd797f9f90da230c972f/4%E6%91%A9%E6%89%98%E8%BD%A6%E9%AA%91%E8%A1%8C%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    // 潜水套餐
    [
      [3625, 3617],
      [
        'https://res.insta360.com/static/93e41d9ccf8d2b0b7b3ff0048cf9589a/1%E6%BD%9C%E6%B0%B4%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/a7fd3a4cec0b09d2d2fdd8d1078ea390/2%E6%BD%9C%E6%B0%B4%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/3e731e0cd82207ba2cac29c5a4bb43ad/3%E6%BD%9C%E6%B0%B4%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
    // 滑雪套餐
    [
      [3626, 3618],
      [
        'https://res.insta360.com/static/18da7a0a2cc84a4da1e20bd57ef5e42c/1%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/40220686e05a933d33c387cd921bf6b1/2%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/f660806b28f20789fc1391cab82ffd8c/3%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90.jpg',
        'https://res.insta360.com/static/962c933e704fe46048d1e383a434183a/4%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90.jpg',
      ],
    ],
  ]);

  for (const [range, config] of AP2ABTSource) {
    if (range.includes(cid)) {
      // 标准套餐则直接拼到最后面
      if ([3619, 3611].includes(cid)) {
        displayResources.push(
          ...config.map((url) => ({
            url: ossImgCompress(url, { webp, width: 1280, height: 1280 }),
            urlL: ossImgCompress(url, { webp }),
            url_m: ossImgCompress(url, { webp, width: 1280, height: 1280 }),
            url_s: ossImgCompress(url, { webp, width: 124, height: 124 }),
          }))
        );
      } else {
        // 非标准套餐保留一号位图，后面全部替换
        const displayLength = displayResources.length;
        displayResources.splice(
          1,
          displayLength - 1,
          ...config.map((url) => ({
            url: ossImgCompress(url, { webp, width: 1280, height: 1280 }),
            urlL: ossImgCompress(url, { webp }),
            url_m: ossImgCompress(url, { webp, width: 1280, height: 1280 }),
            url_s: ossImgCompress(url, { webp, width: 124, height: 124 }),
          }))
        );
      }
    }
  }
};

/** 自拍杆主图物料优化 ABT */
const hanldeSelfieStickABT = (cid, displayResources, group, webp) => {
  if (!cid || !group) return [];

  const groupOne = {
    2141: [
      'https://res.insta360.com/static/15e2aff635d4fa3f23c4ca6b3ff50ffe/01.png',
      'https://res.insta360.com/static/e47a40ca0fa926f370050bc792982241/02.jpg',
      'https://res.insta360.com/static/8c350ada15f1f0dfe61c8fa25289640f/03.jpg',
      'https://res.insta360.com/static/5d5c294a717a40692025afcabf74f28f/04.jpg',
      'https://res.insta360.com/static/a23367bc1dec28803b85aefa56c286f3/05.jpg',
      'https://res.insta360.com/static/551de7fd2b58967e4930204d9f46268c/06.jpg',
      'https://res.insta360.com/static/c5d8bc78c50ab097a370fede6d4be8d7/07.png',
      'https://res.insta360.com/static/dd933906fdcce43de3da84369df5967b/08.png',
      'https://res.insta360.com/static/1829562c81e8b1db706b398bd4a147ac/09.png',
    ],
    1344: [
      'https://res.insta360.com/static/4b781006f5ca2dbb00d5a56fc8fa1d53/01.png',
      'https://res.insta360.com/static/cc928de894e369d5f8505cf0a8e6c14c/02.jpg',
      'https://res.insta360.com/static/ae6fe1268b221aa91997b02be1393b4b/03.jpg',
      'https://res.insta360.com/static/cc238974ee39a30f0c945254f4e342de/04.png',
      'https://res.insta360.com/static/957dc0cca044ed80a7b1939991ae1610/05.png',
      'https://res.insta360.com/static/b0e96d7e76ae619d12880624b3f7981a/06.png',
    ],
    2601: [
      'https://res.insta360.com/static/142d0dd21862826dcfd323f43e702e0b/01.png',
      'https://res.insta360.com/static/3f20a4e477b96ead7cabc188c899ce83/02.jpg',
      'https://res.insta360.com/static/b4d0a24f599f0b28ecb4ccfc4e8dca71/03.jpg',
      'https://res.insta360.com/static/2897397bc71ec21bc62026a3f80e4728/04.jpg',
      'https://res.insta360.com/static/776f2b035cff98d9777910c018797c8a/05.jpg',
      'https://res.insta360.com/static/0f7376e54eccc07670f4bdc3a3d34d0a/06.jpg',
      'https://res.insta360.com/static/23f071acdf4f9f3c011ec8d959f3ca91/07.jpg',
      'https://res.insta360.com/static/2070f2ca427930ae378a6a6ab92be68b/08.png',
      'https://res.insta360.com/static/52822bdc1c8e743d393e105080c6dbe6/09.png',
      'https://res.insta360.com/static/2e44f2218b7144d94cd7cd434a7eff8f/10.png',
    ],
  };
  const groupTwo = {
    2141: [
      'https://res.insta360.com/static/cc77b0f80d1dd7e65a9c6970e81153c3/01.png',
      'https://res.insta360.com/static/550539d26638c69246fbb972921a5d8c/02.jpg',
      'https://res.insta360.com/static/0b8f43bfad7aa8261274d82e187e6d1f/03.jpg',
      'https://res.insta360.com/static/3d8fba4a98374169561c260c8900b64f/04.jpg',
      'https://res.insta360.com/static/678c76b01476db03e36c6f20c92ae025/05.jpg',
      'https://res.insta360.com/static/6078bc0d08f7ae427739c449e4d7c385/06.jpg',
      'https://res.insta360.com/static/63b87e810b4b76300050881fd025ced0/07.png',
      'https://res.insta360.com/static/2d38a0288fc2309efec7b2a43728f81c/08.png',
      'https://res.insta360.com/static/11b8cb4b401d88a6b8011bfd5353037d/09.png',
    ],
    1344: [
      'https://res.insta360.com/static/7756c47e7cb40c749d7f95e2b59efbc2/01.png',
      'https://res.insta360.com/static/4d3fb41525ae8e8eacef286da668f0c5/02.jpg',
      'https://res.insta360.com/static/c8e8b71e113560efcc90b0144122e722/03.jpg',
      'https://res.insta360.com/static/2201066926919ca5a96342fcc1af6bbc/04.png',
      'https://res.insta360.com/static/27489bcb14c8262a6503bd097df9c910/05.png',
      'https://res.insta360.com/static/682e912f9255e009028931b5e85e41fe/06.png',
    ],
    2601: [
      'https://res.insta360.com/static/98f9650101f60604870a3358ce4d5702/01.png',
      'https://res.insta360.com/static/eee43750216f0e5dc1a99d76ba68fb67/02.jpg',
      'https://res.insta360.com/static/e3fa981248bb63c16e8e578908f962c8/03.jpg',
      'https://res.insta360.com/static/d546f6ae6b819c364dd70ca8744d47d1/04.jpg',
      'https://res.insta360.com/static/33b57e64a34ac9d7a3048327cc861120/05.jpg',
      'https://res.insta360.com/static/10c371f25b3115b83859e734f09256b3/06.jpg',
      'https://res.insta360.com/static/5627c96fbbf3727cfcfb7cbf313aa781/07.jpg',
      'https://res.insta360.com/static/f0f343b6ff50e02e1dd2baff7c01ea3e/08.png',
      'https://res.insta360.com/static/1ba60bb855eab4686422606f54e48362/09.png',
      'https://res.insta360.com/static/6b16f0a44bef93526e4f28cd318c53e7/10.png',
    ],
  };

  const variation = group === 'groupOne' ? groupOne[cid] : groupTwo[cid];

  return variation.map((item) => {
    return {
      ...displayResources,
      url: ossImgCompress(`${item}`, { webp }),
      urlL: '',
      url_m: ossImgCompress(item, { webp }),
      url_s: ossImgCompress(item, { webp, width: 124, height: 124 }),
    };
  });
};

export default {
  GO3SSceneMastListForABTesting,
  handleGO3SProductSceneABTest,
  GO3SProductSceneCommodities,
  getSnowKitSceneConfig,
  onex2ProductSceneCommodities,
  onex2ProductSceneCountry,
  hanldeAP2ABT,
  hanldeSelfieStickABT,
};
